module.exports = __webpack_public_path__ + "img/pd-img34.7c8a75fc.jpg";